import { faKey } from '@fortawesome/pro-regular-svg-icons'

export const getUserViewRoutes = ({ history, showSessionLogs, isMFAEnabled }) => {
  const views = [
    {
      itemType: 'section',
      label: 'directory'
    },
    {
      CustomIcon: <span className='material-symbols-outlined text-[18px]'>deployed_code</span>,
      label: 'Bundles',
      variant: 'primary',
      onClick() {
        history.push('/user/bundles')
      },
      _meta: {
        itemActiveRoutes: '/user/bundles'
      }
    },
    {
      icon: faKey,
      label: 'Service Accounts',
      variant: 'primary',
      onClick() {
        history.push('/user/service-accounts/aws')
      },
      _meta: {
        itemActiveRoutes: '/user/service-accounts/aws'
      }
    },
    {
      itemType: 'section',
      label: 'cloud'
    },
    {
      CustomIcon: <span className='material-symbols-outlined text-[18px]'>stacks</span>,
      label: 'Targets',
      variant: 'primary',
      onClick() {
        history.push('/user/targets')
      },
      _meta: {
        itemActiveRoutes: '/user/targets'
      }
    },
    {
      CustomIcon: (
        <span className='material-symbols-outlined text-[18px]'>domain_verification</span>
      ),
      label: 'Resources',
      variant: 'primary',
      onClick() {
        history.push('/user/resources')
      },
      _meta: {
        itemActiveRoutes: '/user/resources'
      }
    },
    {
      CustomIcon: <span className='material-symbols-outlined text-[18px]'>apps</span>,
      label: 'applications',
      variant: 'primary',
      onClick() {
        history.push('/user/applications')
      },
      _meta: {
        itemActiveRoutes: '/user/applications'
      }
    },

    {
      itemType: 'section',
      label: 'Access Management'
    },
    {
      CustomIcon: <span className='material-symbols-outlined text-[18px]'>engineering</span>,
      label: 'IAM Roles',
      variant: 'primary',
      onClick() {
        history.push('/user/iam-roles/aws')
      },
      _meta: {
        itemActiveRoutes: '/user/iam-roles'
      }
    },
    {
      CustomIcon: <span className='material-symbols-outlined text-[18px]'>psychology_alt</span>,
      label: 'Access Requests',
      variant: 'primary',
      onClick() {
        history.push('/user/access-requests')
      },
      _meta: {
        itemActiveRoutes: '/user/access-requests'
      }
    },

    {
      CustomIcon: (
        <span className='material-symbols-outlined text-[18px]'>assignment_turned_in</span>
      ),
      label: 'Policies',
      variant: 'primary',
      onClick() {
        history.push('/user/policys')
      },
      _meta: {
        itemActiveRoutes: '/user/policys'
      }
    },
    {
      itemType: 'section',
      label: 'devices'
    },
    {
      CustomIcon: <span className='material-symbols-outlined text-[18px]'>devices</span>,
      label: 'devices',
      variant: 'primary',
      onClick() {
        history.push('/user/devices')
      },
      _meta: {
        itemActiveRoutes: '/user/devices'
      }
    },
    {
      CustomIcon: <span className='material-symbols-outlined text-[18px]'>lan</span>,
      label: 'RDP User Management',
      variant: 'primary',
      onClick() {
        history.push('/user/addomaincontrollers')
      },
      _meta: {
        itemActiveRoutes: '/user/addomaincontrollers'
      }
    },
    {
      itemType: 'section',
      label: 'Activity'
    },
    {
      CustomIcon: <span className='material-symbols-outlined text-[18px]'>vital_signs</span>,
      label: 'activity logs',
      variant: 'primary',
      onClick() {
        history.push('/user/activity-logs')
      },
      _meta: {
        itemActiveRoutes: '/user/activity-logs'
      }
    }
  ]

  if (showSessionLogs) {
    views.push({
      CustomIcon: <span className='material-symbols-outlined text-[18px]'>show_chart</span>,
      label: 'Session Logs',
      variant: 'primary',
      onClick() {
        history.push('/user/session-logs')
      },
      _meta: {
        itemActiveRoutes: '/user/session-logs'
      }
    })
  }

  return views
}
